import { FeatureType } from '@apply/constants';

/* full menu should be 200px width - TBD Future Cards */
export const navigation = [
    { id: 1, text: 'Home', icon: 'home', navigateUrl: '/home' },
    // { id: 2, text: 'Profile', icon: 'user' },
    {
        id: 3,
        text: 'Business and People',
        icon: 'group',
        navigateUrl: '/businessandpeople',
        featureFlag: FeatureType.BusinessAndPeopleHierarchy,
    },
    {
        id: 4,
        text: 'Experience',
        icon: 'favorites',
        navigateUrl: '/experience',
        featureFlag: FeatureType.Experience,
    },
    { id: 5, text: 'Notifications', icon: 'bell', navigateUrl: '/notices' },
    // { id: 6, text: 'Applications', icon: 'export'},
    // { id: 7, text: 'Outstanding Loans', icon: 'money' }
];
